import { getPageIdInfo, loadJS } from "../../utils/common";
import { miniwebviewocd } from "../../utils/initLoadSdk";
var pullMiniH5OCD = function pullMiniH5OCD() {
  var pageInfo = getPageIdInfo();
  var pageId = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.pageId;
  var existingScript = document.querySelector("script[src^=\"".concat(miniwebviewocd, "\"]"));
  if (!pageId || existingScript) return;
  var timestamp = new Date().getTime();
  var url = "".concat(miniwebviewocd, "?t=").concat(timestamp);
  loadJS(url, function () {});
};
export default pullMiniH5OCD;